import oidcConfig from '@/helpers/oidc.config';
import { vuexOidcCreateStoreModule } from 'vuex-oidc';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

const oidcModule = vuexOidcCreateStoreModule(
  oidcConfig,
  { dispatchEventsOnWindow: true },
  {
    userLoaded: user => console.log('OIDC user is loaded:', user),
    userUnloaded: () => console.log('OIDC user is unloaded'),
    accessTokenExpiring: () => console.log('Access token will expire'),
    accessTokenExpired: () => console.log('Access token did expire'),
    silentRenewError: () => console.log('OIDC user is unloaded'),
    userSignedOut: () => console.log('OIDC user is signed out'),
  }
);

export default {
  namespaced: true,
  actions: {
    ...actions,
    ...oidcModule.actions,
  },
  getters: {
    ...getters,
    ...oidcModule.getters,
  },
  mutations: {
    ...mutations,
    ...oidcModule.mutations,
  },
  state: {
    ...state,
    ...oidcModule.state,
  },
};
